"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HbtServiceErrorCodes = void 0;
var http_1 = require("../http");
/**
 * Error Codes that are used when throwing new HBT Errors.
 * Each code object consists of a
 *
 * Note: Do not use httpCode: 408, it can cause the lambda to infinite loop
 */
exports.HbtServiceErrorCodes = {
    /*
     * HBT Error Codes - SERVER
     */
    HBT_ERR_SERVER: {
        code: 'HBT_ERR_1000',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Server Error',
    },
    /*
     * HBT Error Codes - BAD REQUEST
     */
    HBT_ERR_BAD_REQUEST: {
        code: 'HBT_ERR_1100',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Bad Request',
    },
    /*
     * HBT Error Codes - NOT AUTHORIZED
     */
    HBT_ERR_NOT_AUTHORIZED: {
        code: 'HBT_ERR_1101',
        httpCode: http_1.HttpResponseStatusCodes.Unauthorized,
        message: 'Not Authorized',
    },
    /*
     * HBT Error Codes - FORBIDDEN
     */
    HBT_ERR_FORBIDDEN: {
        code: 'HBT_ERR_1102',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'Forbidden',
    },
    /*
     * HBT Error Codes - NOT FOUND
     */
    HBT_ERR_NOT_FOUND: {
        code: 'HBT_ERR_1103',
        httpCode: http_1.HttpResponseStatusCodes.NotFound,
        message: 'Not Found',
    },
    /*
     * HBT Error Codes - NOT_IMPLEMENTED
     */
    HBT_ERR_NOT_IMPLEMENTED: {
        code: 'HBT_ERR_1001',
        httpCode: http_1.HttpResponseStatusCodes.NotImplemented,
        message: 'Not Implemented',
    },
    /*
     * HBT Error Codes - BAD_GATEWAY
     */
    HBT_ERR_BAD_GATEWAY: {
        code: 'HBT_ERR_1002',
        httpCode: http_1.HttpResponseStatusCodes.BadGateway,
        message: 'Bad Gateway',
    },
    /*
     * HBT Error Codes - SERVICE UNAVAILABLE
     */
    HBT_ERR_SERVICE_UNAVAILABLE: {
        code: 'HBT_ERR_1003',
        httpCode: http_1.HttpResponseStatusCodes.ServiceUnavailable,
        message: 'Service Unavaliable',
    },
    /*
     * HBT Error Codes - GATEWAY_TIMEOUT
     */
    HBT_ERR_GATEWAY_TIMEOUT: {
        code: 'HBT_ERR_1004',
        httpCode: http_1.HttpResponseStatusCodes.GatewayTimeout,
        message: 'Gateway Timeout',
    },
    /*
     * HBT Error Codes - SESSION
     */
    HBT_ERR_SESSION_EXPIRED: {
        code: 'HBT_ERR_2000',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Session Expired',
    },
    /**
     * HBT Error Codes - Params
     */
    HBT_ERR_MISSING_REQ_PARAM: {
        code: 'HBT_ERR_3000',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Missing Required Parameter',
    },
    HBT_ERR_MISSING_PATH_PARAM: {
        code: 'HBT_ERR_3001',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Missing Path Parameter',
    },
    HBT_ERR_MISSING_BODY_PARAM: {
        code: 'HBT_ERR_3002',
        httpCode: http_1.HttpResponseStatusCodes.UnprocessableEntity,
        message: 'Missing Body Parameter',
    },
    HBT_ERR_INVALID_PARAM: {
        code: 'HBT_ERR_3003',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Invalid Parameter',
    },
    /**
     * HBT Error Codes - DB
     */
    HBT_ERR_DB_CLIENT: {
        code: 'HBT_ERR_4000',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Database Error',
    },
    HBT_ERR_RECORD_NOT_FOUND: {
        code: 'HBT_ERR_4001',
        httpCode: http_1.HttpResponseStatusCodes.NotFound,
        message: 'Record Not Found',
    },
    HBT_ERR_DB_DUPLICATE_RECORD: {
        code: 'HBT_ERR_4002',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Duplicate Record Found in Database',
    },
    /**
     * HBT Error Codes - DOMAIN ERRORS
     */
    HBT_ERR_VALIDATION: {
        code: 'HBT_ERR_5000',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Validation Error',
    },
    HBT_ERR_DUPLICATE_DRAFT_CLAIM: {
        code: 'HBT_ERR_5003',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'A Draft Claim already exists for the given CMHC Loan Account Number',
    },
    HBT_ERR_PROCESS_IN_MICS_CLAIM: {
        code: 'HBT_ERR_5004',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'A Process in Mics Claim already exists for the given CMHC Loan Account Number',
    },
    HBT_ERR_DUPLICATE_LOAN_NUMBER: {
        code: 'HBT_ERR_5008',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'A Default Submission in Pending, In Review, or Inactive exists with this CMHC Loan Account Number',
    },
    HBT_ERR_MAX_BORROWERS: {
        code: 'HBT_ERR_5009',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Cannot have more than 10 borrowers',
    },
    HBT_ERR_ACCOUNT_NUMBER: {
        code: 'HBT_ERR_5010',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Invalid Account Number Error',
    },
    HBT_ERR_ACCOUNT_NUMBER_STATUS: {
        code: 'HBT_ERR_5011',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Invalid Account Number Status Error',
    },
    HBT_ERR_DUPLICATE_REFERENCE_NUMBER: {
        code: 'HBT_ERR_5012',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'A Issue to Management record with this reference number already exists',
    },
    HBT_ERR_INVALID_MLG_LOAN: {
        code: 'HBT_ERR_5013',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'CMHC Loan Number falls under MLG loan and cannot be submitted',
    },
    HBT_ERR_NONEXISTENT_LOAN: {
        code: 'HBT_ERR_5014',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'CMHC Loan Number does not exist',
    },
    HBT_ERR_NOT_LATEST_INSURANCE_POLICY_LOAN: {
        code: 'HBT_ERR_5015',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'CMHC Loan Number is not the latest insurance policy',
    },
    HBT_ERR_UNSUPPORTED_LEGACY_LOAN: {
        code: 'HBT_ERR_5016',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'CMHC Loan Number is not supported by this platform',
    },
    HBT_ERR_LOAN_INACTIVE_STATUS_LOAN: {
        code: 'HBT_ERR_5017',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'CMHC Loan Number has an inactive status',
    },
    HBT_ERR_PREMIUM_FEES_NOT_FULLY_PAID_LOAN: {
        code: 'HBT_ERR_5018',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Premium and/or fees have not been fully paid for the given CMHC Loan Number',
    },
    HBT_ERR_UNPAID_CLAIM_IN_PROGRESS: {
        code: 'HBT_ERR_5019',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'A new claim submission cannot be accepted as at least one unpaid claim is in progress',
    },
    HBT_ERR_MAIN_CLAIM_IN_PROGRESS: {
        code: 'HBT_ERR_5020',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Main claim is paid or in progress',
    },
    HBT_ERR_NO_OR_UNPAID_MAIN_CLAIM: {
        code: 'HBT_ERR_5021',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Main Claim does not exist or is currently in progress for this CMHC Loan Number',
    },
    HBT_ERR_CLAIM_REASSIGNMENT_ALREADY_ASSIGNED: {
        code: 'HBT_ERR_5022',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'The claim is already assigned to the selected user.',
    },
    HBT_ERR_CLAIM_REASSIGNMENT_INVALID_STATUS: {
        code: 'HBT_ERR_5023',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'The claim cannot be assigned with the current status.',
    },
    HBT_ERR_CLAIM_REASSIGNMENT_INVALID_USER: {
        code: 'HBT_ERR_5024',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'The claim is not allowed to be assigned to this user.',
    },
    HBT_ERR_CLAIM_CANNOT_BE_CANCELLED: {
        code: 'HBT_ERR_5025',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'The claim could not be cancelled due to the existing status.',
    },
    HBT_ERR_NO_ACPP_AGREEMENT_WITH_LENDER: {
        code: 'HBT_ERR_5026',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'No agreement with Lender for Enhanced ACPP.',
    },
    HBT_ERR_CLAIM_CANNOT_BE_CONTESTED: {
        code: 'HBT_ERR_5027',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'The claim cannot be contested as it is not declined or user do not have the appropriate permissions.',
    },
    HBT_ERR_CLAIM_CANNOT_BE_DECLINED: {
        code: 'HBT_ERR_5028',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'The claim cannot be declined due to the current status or the user is not a valid user',
    },
    HBT_ERR_CLAIM_LEGACY_FI_NOT_FOUND: {
        code: 'HBT_ERR_5029',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'The claim has no legacy financial institution.',
    },
    HBT_ERR_CLAIM_PROCESSING_TYPE_RECORD_NOT_FOUND: {
        code: 'HBT_ERR_5030',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'No Legacy Lender Claim Processing Type Record found for Lender.',
    },
    HBT_ERR_APPROVED_LENDER_NOT_FOUND: {
        code: 'HBT_ERR_5031',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'No Approved Lender found for Claim.',
    },
    HBT_ERR_MAIN_FINAL_CLAIM_NOT_FOUND: {
        code: 'HBT_ERR_5032',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'No Main Final Claim found for Supplementary Claim.',
    },
    HBT_ERR_FINAL_CLAIM_EMAIL_ADDRESS_NOT_FOUND: {
        code: 'HBT_ERR_5033',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Could not find email address for submitterUserID',
    },
    HBT_ERR_FINAL_CLAIM_CANNOT_AUTO_APPROVE: {
        code: 'HBT_ERR_5034',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Cannot change the status of the claim if it is Auto-Approved',
    },
    HBT_ERR_FINAL_CLAIM_CANNOT_UPDATE_TO_AUTO_APPROVE: {
        code: 'HBT_ERR_5035',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Cannot change the status of the claim to Auto-Approved',
    },
    HBT_ERR_AUTO_ADJUDICATION_DECLINED: {
        code: 'HBT_ERR_5036',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Claim requires manual approval as it does not meet auto-adjudication criteria.',
    },
    HBT_ERR_CANNOT_APPROVE_PENDING_CLAIM: {
        code: 'HBT_ERR_5037',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Claim cannot be approved if it is in Pending status.',
    },
    HBT_ERR_LENDER_INFORMATION_MISMATCH: {
        code: 'HBT_ERR_5038',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Lender information does not match the main claim.',
    },
    HBT_ERR_CANNOT_DELETE_CLAIM_OUT_OF_ORDER: {
        code: 'HBT_ERR_5039',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Higher claim sequence found. Please delete the higher claim sequence first.',
    },
    /**
     * HBT Error Codes - DOCUMENT SERVICE
     */
    HBT_ERR_MISSING_FILE_PARAM: {
        code: 'HBT_ERR_6001',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Missing file parameter',
    },
    HBT_ERR_MISSING_DOCUMENT_TYPE_PARAM: {
        code: 'HBT_ERR_6002',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Missing document type parameter',
    },
    HBT_ERR_INVALID_MIME_TYPE: {
        code: 'HBT_ERR_6003',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Invalid mime type',
    },
    HBT_ERR_FILE_SIZE: {
        code: 'HBT_ERR_6004',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'File size is greater than allowed limit',
    },
    HBT_ERR_INVALID_FILE_COUNT: {
        code: 'HBT_ERR_6005',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Invalid file count',
    },
    HBT_ERR_DOCUMENT_UPLOAD: {
        code: 'HBT_ERR_6006',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Document upload error',
    },
    HBT_ERR_EMPTY_DOCUMENT: {
        code: 'HBT_ERR_6007',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Empty document',
    },
    HBT_ERR_BLOB_STORAGE: {
        code: 'HBT_ERR_6008',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Blob Storage Error',
    },
    HBT_ERR_MISSING_DEFAULT_ID: {
        code: 'HBT_ERR_6009',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Missing Default ID',
    },
    HBT_ERR_DOCUMENT_NOT_FOUND: {
        code: 'HBT_ERR_6010',
        httpCode: http_1.HttpResponseStatusCodes.NoContent,
        message: 'Document not found',
    },
    HBT_ERR_FILE_NAME_SIZE: {
        code: 'HBT_ERR_6011',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Invalid File Name, cannot be more than 100 characters',
    },
    HBT_INVALID_FILE_FORMAT: {
        code: 'HBT_ERR_6012',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Invalid document format',
    },
    HBT_ERR_FILE_NAME_SPECIAL_CHARACTERS: {
        code: 'HBT_ERR_6013',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'Invalid File Name, should not contain special characters',
    },
    /**
     * HBT Error Codes - AUTHORIZATION
     */
    HBT_ERR_USER_AD_STATUS: {
        code: 'HBT_ERR_7001',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'The AD user account is not ACTIVE',
    },
    HBT_ERR_USER_HBT_STATUS: {
        code: 'HBT_ERR_7002',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'The HBT user account is not ACTIVE',
    },
    HBT_ERR_USER_NOT_FOUND: {
        code: 'HBT_ERR_7003',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'HBT user not found',
    },
    HBT_ERR_SCOPE: {
        code: 'HBT_ERR_7005',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'Scope Error',
    },
    HBT_ERR_TOKEN: {
        code: 'HBT_ERR_7006',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'Bearer Token Error',
    },
    HBT_ERR_ROUTES: {
        code: 'HBT_ERR_7007',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'Route Error',
    },
    HBT_ERR_DECODE: {
        code: 'HBT_ERR_7008',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'Decode Error',
    },
    HBT_ERR_VERIFY: {
        code: 'HBT_ERR_7009',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'Verification Error',
    },
    HBT_ERR_MS_GRAPH: {
        code: 'HBT_ERR_7010',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'MS Graph Fetch Error',
    },
    HBT_ERR_PROXY: {
        code: 'HBT_ERR_7011',
        httpCode: http_1.HttpResponseStatusCodes.Forbidden,
        message: 'Proxy Error',
    },
    /**
     * HBT Error Codes - OTHER
     */
    HBT_ERR_INVALID_HBT_ERR: {
        code: 'HBT_ERR_8000',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: '',
    },
    HBT_ERR_SIGTERM: {
        code: 'HBT_ERR_8001',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: '',
    },
    HBT_ERR_CONFIG: {
        code: 'HBT_ERR_8003',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Configuration Error',
    },
    HBT_DATA_MAPPING: {
        code: 'HBT_ERR_8004',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'Data Mapping Error',
    },
    /**
     * HBT Error Codes - USER MANAGEMENT
     */
    HBT_ERR_INCONSISTENT_EMAIL_USERTYPE: {
        code: 'HBT_ERR_9000',
        httpCode: http_1.HttpResponseStatusCodes.BadRequest,
        message: 'the email domain is not consistent with the userType',
    },
    /**
     * HBT Error Codes - EXTERNAL APIs
     */
    HBT_ERR_DMP_FAILURE: {
        code: 'HBT_ERR_10000',
        httpCode: http_1.HttpResponseStatusCodes.ServerError,
        message: 'there was a failure while making an API call to DMP',
    },
};
exports.default = exports.HbtServiceErrorCodes;
